import { useFormikContext } from 'formik';
import React from 'react';
import { ShareCustomFields } from '../../form/fields/custom-fields';
import { ShareLinkFieldType, ShareLinkFormType } from '../../form/link-config-form.factory';

export const ShareConfigCustomFieldsPanel = () => {
  const { values, setFieldValue } = useFormikContext<ShareLinkFormType>();

  const onFieldChange = (payload: ShareLinkFieldType<unknown>) => {
    setFieldValue(payload.field, payload.value);
  };

  return <ShareCustomFields onFieldChange={onFieldChange} customFields={values.custom_fields || []} />;
};
